<template>
    <div>
        <h3 style="text-align: center">แก้ไขจำนวนเงินประกัน</h3>
        <br>
        <div class="row">
            <div class="col-sm-4 text-right">
                <label>จำนวนเงินประกัน</label>
            </div>
            <div class="col-sm-5">
                <input v-model="form.insurance_total"
                       class="form-control"
                       type="number"/>
            </div>
        </div>
        <br>
        <div class="col text-center">
            <button @click="submitInsurance"
                    type="button"
                    class="btn btn-success">
                <icon name="save" style="width: 25px"></icon> บันทึก</button>&nbsp&nbsp
            <button type="button"
                    @click="cancelInsurance"
                    class="btn btn-outline-secondary">
                <icon name="times" style="width: 25px"></icon> ยกเลิก
            </button>
        </div>
        <br/>
        <!--<pre class="alert-primary">{{insurance_total}}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";

    export default {
        name: "insurance-modal",
        data(){
            return{

            }
        },
        computed:{
            ...mapState({
                form : state=>{
                    return state.InsuranceFee.form
                }
            })
        },
        methods:{
            submitInsurance(){
                this.$emit('submit',this.form.insurance_total);
            },
            cancelInsurance(){
                this.$emit('submit',false);
            }
        }
    }
</script>

<style scoped>

</style>